module.exports = __webpack_public_path__ + "static/media/map-pin.b2f804bd.svg";